import { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosInstance";
import moment from "moment";

import { useNavigate, Link } from "react-router-dom";
import ClientLayout from "./components/layout/ClientLayout";
import GamesSlider from "./components/GamesSlider";
import RaceSlider from "./components/RaceSlider";
import EventRow from "./components/EventRow";
import { useSelector, useDispatch } from "react-redux";
import { refreshSessionData } from "../../utils/refreshSessionData";

const cricketMatchList = [];

let inplayCount = 0;
let cricketCount = 0;
let footballCount = 0;
let tennisCount = 0;

export default function Home() {
  const dispatch = useDispatch();
  const eventsFromParent = useSelector((state) => state.event);
  const userInfo = useSelector((state) => state.userStore);
  const userId = userInfo.data?._id;

  // Refresh all slices (user, events, exposure) whenever /home is visited.
  useEffect(() => {
    if (!userId) return;
    refreshSessionData(dispatch).catch((err) => {
      console.error("Home: slice refresh failed:", err);
    });
  }, [userId, dispatch]);

  const username = userInfo.data?.uname ?? "";
  const balance = Math.round(userInfo.data?.bz_balance ?? 0);
  const credit_reference = Math.round(userInfo.data?.credit_reference ?? 0);
  const expouser = Math.round(
    (userInfo.data?.opin_bal ?? 0) - (userInfo.data?.bz_balance ?? 0)
  );

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  //console.log("Events from Redux Store Home:", eventsFromParent);

  /**
 * Want to disucss the following:
 * 
 
const [data, setData] = useState(null);
const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios.get('/events').then(res => {
      setData(res.data);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, []);

 *
  
  const { data, isLoading } = useQuery({
  queryKey: ['posts'],
  queryFn: () => axios.get('/events').then(res => res.data)
  });

  // benefits:
  Less code
  Better cache
  Status states
  Auto refetch
 */
  const [activeIndex, setActiveIndex] = useState(0);

  const showHideDiv = (index) => {
    setActiveIndex(index === activeIndex ? activeIndex : index);
  };

  const [activeEventList, setActiveEventslist] = useState([]);

  const getEvents = (events) => {
    if (!events || !Array.isArray(events.result)) return;
    let inplayEvent = events.result.filter((event) => event.inplay);
    let cricketEvent = events.result.filter((event) => event.sports_type === 1);
    let footballEvent = events.result.filter(
      (event) => event.sports_type === 2
    );
    let tennisEvent = events.result.filter((event) => event.sports_type === 3);

    inplayCount = inplayEvent.length;
    cricketCount = cricketEvent.length;
    footballCount = footballEvent.length;
    tennisCount = tennisEvent.length;

    const length = events.result.length;

    //setActiveEventslist(...activeEventList, events.result);
    setActiveEventslist(events);
  };

  useEffect(() => {
    if (Array.isArray(eventsFromParent?.data?.result)) {
      getEvents(eventsFromParent.data);
    }
  }, [eventsFromParent]);

  useEffect(() => {
    const fetchEvents = async () => {
      //console.log("Fetching events...");
      try {
        const response = await axiosInstance.get("/events");
        console.log(response.data.result); // displaying all events data

        if (Array.isArray(response.data?.result)) {
          getEvents(response.data);
        }
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    //fetchEvents();

    const fetchEventsById = async (eventId) => {
      console.log("Fetching Single event...");
      try {
        const response = await axiosInstance.get("/events/" + eventId);

        console.log(response.data); // single event data
      } catch (error) {
        console.error("Error fetching single event:", error);
      }
    };

    //fetchEvents();
    //fetchEventsById("6880d5f9dd6f2ac350a6b408");
    //fetchEventsById("1.245404426");
  }, []);

  return (
    <ClientLayout>
      <>
        <div className="balance-bar-wrapper" style={{ marginTop: "3px" }}>
          <ul style={{ marginBottom: "0px" }}>
            <li className="client_family">
              Credit:{" "}
              <span id="bal_credit_header">
                {formatTruncate(credit_reference)}
              </span>
            </li>
            <li className="client_family">
              Balance: <span id="bal_header">{formatTruncate(balance)}</span>
            </li>
            <li className="client_family">
              Liable:{" "}
              <span id="expouser_header">{formatTruncate(expouser)}</span>
            </li>
            <li className="client_family">
              Active Bets: <span>*</span>
            </li>
          </ul>
        </div>
        <div className="games-slider-wrapper" style={{ marginTop: "4px" }}>
          <GamesSlider />
        </div>
        <div className="race-cards-wrapper-row">
          <RaceSlider
            raceTitle="Horse Race"
            raceIcon="horse"
            gameType="4"
            eventList={activeEventList}
          />
        </div>
        <div className="race-cards-wrapper-row">
          <RaceSlider
            raceTitle="Grey Hound"
            raceIcon="greyhound-racing"
            gameType="5"
            eventList={activeEventList}
          />
        </div>

        <div className="tab-panes-wrapper-row">
          <div
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              scrollbarWidth: "thin"
            }}
          >
            <ul
              className="nav nav-tabs"
              role="tablist"
              style={{ display: "flex", listStyle: "none", flexWrap: "nowrap" }}
            >
              <li
                className="nav-item"
                style={{
                  flex: "0 0 auto",
                  cursor: "pointer",
                  whiteSpace: "nowrap"
                }}
              >
                <a
                  className="nav-link active"
                  data-toggle="tab"
                  href="#tabs-1"
                  role="tab"
                  onClick={() => showHideDiv(0)}
                  style={{ background: "#02b181" }}
                >
                  <div className="tabs-row-box">
                    <div className="tabs-box-no">
                      <span id="inplay_count">{inplayCount}</span>
                    </div>
                    <div className="tabs-box-icon">
                      <i className="fa-solid fa-alarm-clock" />
                    </div>
                    <div className="tabs-title-s">Inplay</div>
                  </div>
                </a>
              </li>

              <li
                className="nav-item"
                style={{
                  flex: "0 0 auto",
                  cursor: "pointer",
                  whiteSpace: "nowrap"
                }}
              >
                {" "}
                <a
                  className="nav-link"
                  data-toggle="tab"
                  href="#tabs-2"
                  role="tab"
                  style={{ background: activeIndex === 1 ? "#000000" : "" }}
                  onClick={() => showHideDiv(1)}
                >
                  <div className="tabs-row-box">
                    <div className="tabs-box-no">
                      <span id="cricket_count">{cricketCount}</span>
                    </div>
                    <div className="tabs-box-icon">
                      <img
                        src="/assets/images/menu-icon/cricket.svg"
                        style={{ width: "32px", height: "32px" }}
                        alt="Box Icon"
                      />
                    </div>
                    <div className="tabs-title-s">Cricket</div>
                  </div>
                </a>{" "}
              </li>

              <li
                className="nav-item"
                style={{
                  flex: "0 0 auto",
                  cursor: "pointer",
                  whiteSpace: "nowrap"
                }}
              >
                {" "}
                <a
                  className="nav-link"
                  data-toggle="tab"
                  href="#tabs-3"
                  role="tab"
                  style={{ background: activeIndex === 3 ? "#000000" : "" }}
                  onClick={() => showHideDiv(3)}
                >
                  <div className="tabs-row-box">
                    <div className="tabs-box-no">
                      <span id="tennis_count">{tennisCount}</span>
                    </div>
                    <div className="tabs-box-icon">
                      <img
                        src="/assets/images/menu-icon/tennis.svg"
                        style={{ width: "32px", height: "32px" }}
                        alt="Box Icon"
                      />
                    </div>
                    <div className="tabs-title-s">Tennis</div>
                  </div>
                </a>{" "}
              </li>

              <li
                className="nav-item"
                style={{
                  flex: "0 0 auto",
                  cursor: "pointer",
                  whiteSpace: "nowrap"
                }}
              >
                {" "}
                <a
                  className="nav-link"
                  data-toggle="tab"
                  href="#tabs-4"
                  role="tab"
                  style={{ background: activeIndex === 2 ? "#000000" : "" }}
                  onClick={() => showHideDiv(2)}
                >
                  <div className="tabs-row-box">
                    <div className="tabs-box-no">
                      <span id="football_count">{footballCount}</span>
                    </div>
                    <div className="tabs-box-icon">
                      <img
                        src="/assets/images/menu-icon/soccer.svg"
                        style={{ width: "32px", height: "32px" }}
                        alt="Box Icon"
                      />
                    </div>
                    <div className="tabs-title-s">Soccer</div>
                  </div>
                </a>
              </li>

              <li
                className="nav-item"
                style={{
                  flex: "0 0 auto",
                  cursor: "pointer",
                  whiteSpace: "nowrap"
                }}
              >
                {" "}
                <Link className="nav-link" to="/sports-book">
                  <div className="tabs-row-box">
                    <div className="tabs-box-no">
                      <span id="sportsbook_count">80</span>
                    </div>
                    <div className="tabs-box-icon">
                      <img
                        src="/assets/images/menu-icon/SB_ico.png"
                        style={{ width: "32px", height: "32px" }}
                        alt="Box Icon"
                      />
                    </div>
                    <div className="tabs-title-s">SportsBook</div>
                  </div>
                </Link>
              </li>
            </ul>
          </div>
          {/* Tab panes */}
          <div className="tab-content">
            <div
              className={activeIndex === 0 ? "tab-pane active" : "tab-pane"}
              id="tabs-1"
              role="tabpanel"
            >
              <div className="wrapper-table-home">
                <div className="tabcontent">
                  <div className="high_lights">
                    <table className="table">
                      <thead>
                        <tr>
                          <th colSpan={2} className="sport">
                            <div className="sport">
                              {" "}
                              <svg
                                id="baseball"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 56.7 56.7"
                                style={{ fill: "#000" }}
                              >
                                <defs>
                                  <style
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        "\n                                                            .cls-1 {\n                                                                fill: #fff;\n                                                            }\n                                                            "
                                    }}
                                  />
                                </defs>
                                <title>cricket</title>
                                <path
                                  className="cls-1"
                                  d="M47,8.9a.91.91,0,0,1,.7.3l.9.8a1.12,1.12,0,0,1,.1,1.6L39.8,21.9l1.7,1.4a2.09,2.09,0,0,1,.2,3L21,50.1a2,2,0,0,1-1.6.7,2.39,2.39,0,0,1-1.4-.5l-6-5.1a2.09,2.09,0,0,1-.2-3l2.1-2.4L23.2,29l9.3-10.6a2,2,0,0,1,1.6-.7,2.39,2.39,0,0,1,1.4.5l1.7,1.4L46.1,9.3a1.8,1.8,0,0,1,.9-.4"
                                ></path>
                                <circle
                                  className="cls-1"
                                  cx="40.7"
                                  cy="43.3"
                                  r="5.4"
                                />
                                <polygon
                                  className="cls-1"
                                  points="27.2 56.7 31.5 56.7 31.5 43 27.2 47.9 27.2 56.7"
                                ></polygon>
                                <path
                                  className="cls-1"
                                  d="M17.4,53.8v2.9h4.3V53.6a5,5,0,0,1-2.4.6A16.25,16.25,0,0,1,17.4,53.8Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M8.1,44a5.26,5.26,0,0,1,1.3-4L12,37V4.6a1.71,1.71,0,0,0-1.7-1.8h1.5a.43.43,0,0,1,.4.4v.5a.43.43,0,0,0,.4.4h4.1a.43.43,0,0,0,.4-.4V3.2a.43.43,0,0,1,.4-.4h1.7a1.77,1.77,0,0,0-1.7,1.8V30.7l4.3-4.9V4.6a1.71,1.71,0,0,0-1.7-1.8h1.7a.43.43,0,0,1,.4.4v.5a.43.43,0,0,0,.4.4h4.1a.43.43,0,0,0,.4-.4V3.2a.43.43,0,0,1,.4-.4H29a1.77,1.77,0,0,0-1.7,1.8V19.5l2.8-3.2a4.43,4.43,0,0,1,1.5-1.2V4.6a1.71,1.71,0,0,0-1.7-1.8h-.6a.43.43,0,0,0,.4-.4V1.6a.43.43,0,0,0-.4-.4H27.5a.43.43,0,0,1-.4-.4V.4c-.1-.2-.2-.4-.4-.4H22.6a.43.43,0,0,0-.4.4V.9a.43.43,0,0,1-.4.4H20a.43.43,0,0,0-.4.4.43.43,0,0,0-.4-.4H17.4A.43.43,0,0,1,17,.9V.4a.43.43,0,0,0-.4-.4H12.5a.43.43,0,0,0-.4.4V.9a.43.43,0,0,1-.4.4H9.9a.43.43,0,0,0-.4.4v.8a.43.43,0,0,0,.4.4H9.3A1.77,1.77,0,0,0,7.6,4.7V56.8H12V49.6L9.9,47.8A5.9,5.9,0,0,1,8.1,44ZM19.6,2.5a.43.43,0,0,0,.4.4h-.8C19.4,2.8,19.6,2.7,19.6,2.5Z"
                                ></path>
                                <style
                                  xmlns="http://www.w3.org/1999/xhtml"
                                  type="text/css"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      "\n                                                        "
                                  }}
                                />
                              </svg>{" "}
                              Cricket{" "}
                            </div>
                          </th>
                          <th>Matched</th>
                          <th colSpan={2}>1</th>
                          <th colSpan={2}>X</th>
                          <th colSpan={2}>2</th>
                          <th />
                        </tr>
                      </thead>

                      <tbody>
                        <EventRow
                          eventList={activeEventList}
                          tabName="inplay_cricket"
                        />
                      </tbody>
                    </table>
                  </div>

                  <div className="high_lights">
                    <table className="table">
                      <thead>
                        <tr>
                          <th colSpan={2} className="sport">
                            <div className="sport">
                              {" "}
                              <svg
                                id="soccer"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                              >
                                <defs>
                                  <style
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        "\n                                                            .cls-1 {\n                                                                fill: #fff;\n                                                            }\n                                                            "
                                    }}
                                  />
                                </defs>
                                <title>soccer</title>
                                <path
                                  className="cls-1"
                                  d="M12.5.3A11.34,11.34,0,0,0,10,0,11.34,11.34,0,0,0,7.5.3l2.5.9Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M14.3,19.1a9.83,9.83,0,0,0,3.7-3l-2.4.9Z"
                                />
                                <path
                                  className="cls-1"
                                  d="M19.3,6.3a7.19,7.19,0,0,0-1.2-2.1V6.8L20,8.9A7.71,7.71,0,0,0,19.3,6.3Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M2,16.1a9.83,9.83,0,0,0,3.7,3l-1.3-2Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M1.8,4.2A11.78,11.78,0,0,0,.7,6.1,12.76,12.76,0,0,0,0,8.9L1.8,6.7Z"
                                ></path>
                                <polygon
                                  className="cls-1"
                                  points="7 9.4 8.2 12.9 11.8 12.9 13 9.4 10 7.3 7 9.4"
                                ></polygon>
                                <path
                                  className="cls-1"
                                  d="M14.1,16.6l-2-2.1H7.9l-2,2.1,2,3.2A14.92,14.92,0,0,0,10,20a14.92,14.92,0,0,0,2.1-.2Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M19.2,14a.1.1,0,0,1,.1-.1,9,9,0,0,0,.7-2.7L17.3,8,14.5,9.6l-1.3,3.8,2,2.1Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M.8,14a.1.1,0,0,0-.1-.1A13.43,13.43,0,0,1,0,11.2L2.7,8,5.5,9.6l1.3,3.8-2,2.1Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M5.5,1.1A16.44,16.44,0,0,0,3.3,2.5V6.6L6,8.2,9.2,5.9V2.5Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M14.5,1.1,10.7,2.5V5.9l3.2,2.3,2.7-1.6V2.5A11,11,0,0,0,14.5,1.1Z"
                                ></path>
                              </svg>{" "}
                              Football{" "}
                            </div>
                          </th>
                          <th>Matched</th>
                          <th colSpan={2}>1</th>
                          <th colSpan={2}>X</th>
                          <th colSpan={2}>2</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        <EventRow
                          eventList={activeEventList}
                          tabName="inplay_football"
                        />
                      </tbody>
                    </table>
                  </div>

                  <div className="high_lights">
                    <table className="table">
                      <thead>
                        <tr>
                          <th colSpan={2} className="sport">
                            <div className="sport">
                              {" "}
                              <svg
                                id="baseball"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 56.7 56.7"
                              >
                                <defs>
                                  <style
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        "\n                                                            .cls-1 {\n                                                                fill: #fff;\n                                                            }\n                                                            "
                                    }}
                                  />
                                </defs>
                                <title>tennis</title>
                                <path
                                  className="cls-1"
                                  d="M56.7,49.7,44.2,37.2h0l-4.1-4.1a4.76,4.76,0,0,1-1.2-4.7h0a18.66,18.66,0,0,0,.4-2.5,9.28,9.28,0,0,1-2.4.3,4.87,4.87,0,0,1-1.2-.1h0L20.4,10.8l4.4-4.4a20,20,0,0,1,3.7,2.8,9.92,9.92,0,0,1,2.6-2.4A24,24,0,0,0,15.1,0,15.1,15.1,0,0,0,4.3,4.2C-2.5,10.9-1,23.3,7.5,31.8c4.9,4.9,11.1,7.5,16.8,7.5a16.11,16.11,0,0,0,4.4-.6A4.76,4.76,0,0,1,33,39.9L49.4,56.3h0l.2.2,5.6-5.6,1.5-1.2ZM26.2,20.5l-5.4,5.4L13,18.2l5.4-5.4ZM15.1,3.5a16.33,16.33,0,0,1,7.1,1.6L18.5,8.8,13.4,3.7A7.93,7.93,0,0,1,15.1,3.5Zm-5,.9,6.3,6.3L11,16.2,4.7,9.8a11,11,0,0,1,2-3.1A11.34,11.34,0,0,1,10.1,4.4ZM3.6,16.9a14,14,0,0,1,.1-4.1L9,18.2l-4,4A19.78,19.78,0,0,1,3.6,16.9Zm2.8,7.9L11,20.2,18.8,28l-4.7,4.7A24.72,24.72,0,0,1,10,29.4,26,26,0,0,1,6.4,24.8Zm10.3,9.3L20.8,30l5.7,5.7a15,15,0,0,1-2.2.2A19.19,19.19,0,0,1,16.7,34.1Zm16-1.4a10.29,10.29,0,0,1-3.1,2l-6.8-6.8,5.4-5.4,6.7,6.7A9.88,9.88,0,0,1,32.7,32.7Z"
                                ></path>
                                <circle
                                  className="cls-1"
                                  cx="36.9"
                                  cy="15.6"
                                  r="7.1"
                                />
                              </svg>{" "}
                              Tennis{" "}
                            </div>
                          </th>
                          <th>Matched</th>
                          <th colSpan={2}>1</th>
                          <th colSpan={2}>X</th>
                          <th colSpan={2}>2</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        <EventRow
                          eventList={activeEventList}
                          tabName="inplay_tennis"
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={activeIndex === 1 ? "tab-pane active" : "tab-pane"}
              id="tabs-2"
              role="tabpanel"
            >
              <div className="wrapper-table-home">
                <div className="tabcontent">
                  <div className="high_lights">
                    <table className="table">
                      <thead>
                        <tr>
                          <th colSpan={2} className="sport">
                            <div className="sport">
                              {" "}
                              <svg
                                id="baseball"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 56.7 56.7"
                                style={{ fill: "#000" }}
                              >
                                <defs>
                                  <style
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        "\n                                                            .cls-1 {\n                                                                fill: #fff;\n                                                            }\n                                                            "
                                    }}
                                  />
                                </defs>
                                <title>cricket</title>
                                <path
                                  className="cls-1"
                                  d="M47,8.9a.91.91,0,0,1,.7.3l.9.8a1.12,1.12,0,0,1,.1,1.6L39.8,21.9l1.7,1.4a2.09,2.09,0,0,1,.2,3L21,50.1a2,2,0,0,1-1.6.7,2.39,2.39,0,0,1-1.4-.5l-6-5.1a2.09,2.09,0,0,1-.2-3l2.1-2.4L23.2,29l9.3-10.6a2,2,0,0,1,1.6-.7,2.39,2.39,0,0,1,1.4.5l1.7,1.4L46.1,9.3a1.8,1.8,0,0,1,.9-.4"
                                ></path>
                                <circle
                                  className="cls-1"
                                  cx="40.7"
                                  cy="43.3"
                                  r="5.4"
                                />
                                <polygon
                                  className="cls-1"
                                  points="27.2 56.7 31.5 56.7 31.5 43 27.2 47.9 27.2 56.7"
                                ></polygon>
                                <path
                                  className="cls-1"
                                  d="M17.4,53.8v2.9h4.3V53.6a5,5,0,0,1-2.4.6A16.25,16.25,0,0,1,17.4,53.8Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M8.1,44a5.26,5.26,0,0,1,1.3-4L12,37V4.6a1.71,1.71,0,0,0-1.7-1.8h1.5a.43.43,0,0,1,.4.4v.5a.43.43,0,0,0,.4.4h4.1a.43.43,0,0,0,.4-.4V3.2a.43.43,0,0,1,.4-.4h1.7a1.77,1.77,0,0,0-1.7,1.8V30.7l4.3-4.9V4.6a1.71,1.71,0,0,0-1.7-1.8h1.7a.43.43,0,0,1,.4.4v.5a.43.43,0,0,0,.4.4h4.1a.43.43,0,0,0,.4-.4V3.2a.43.43,0,0,1,.4-.4H29a1.77,1.77,0,0,0-1.7,1.8V19.5l2.8-3.2a4.43,4.43,0,0,1,1.5-1.2V4.6a1.71,1.71,0,0,0-1.7-1.8h-.6a.43.43,0,0,0,.4-.4V1.6a.43.43,0,0,0-.4-.4H27.5a.43.43,0,0,1-.4-.4V.4c-.1-.2-.2-.4-.4-.4H22.6a.43.43,0,0,0-.4.4V.9a.43.43,0,0,1-.4.4H20a.43.43,0,0,0-.4.4.43.43,0,0,0-.4-.4H17.4A.43.43,0,0,1,17,.9V.4a.43.43,0,0,0-.4-.4H12.5a.43.43,0,0,0-.4.4V.9a.43.43,0,0,1-.4.4H9.9a.43.43,0,0,0-.4.4v.8a.43.43,0,0,0,.4.4H9.3A1.77,1.77,0,0,0,7.6,4.7V56.8H12V49.6L9.9,47.8A5.9,5.9,0,0,1,8.1,44ZM19.6,2.5a.43.43,0,0,0,.4.4h-.8C19.4,2.8,19.6,2.7,19.6,2.5Z"
                                ></path>
                                <style
                                  xmlns="http://www.w3.org/1999/xhtml"
                                  type="text/css"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      "\n                                                        "
                                  }}
                                />
                              </svg>{" "}
                              Cricket{" "}
                            </div>
                          </th>
                          <th>Matched</th>
                          <th colSpan={2}>1</th>
                          <th colSpan={2}>X</th>
                          <th colSpan={2}>2</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        <EventRow
                          eventList={activeEventList}
                          tabName="cricket"
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={activeIndex === 3 ? "tab-pane active" : "tab-pane"}
              id="tabs-3"
              role="tabpanel"
            >
              <div className="wrapper-table-home">
                <div className="tabcontent">
                  <div className="high_lights">
                    <table className="table">
                      <thead>
                        <tr>
                          <th colSpan={2} className="sport">
                            <div className="sport">
                              {" "}
                              <svg
                                id="baseball"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 56.7 56.7"
                              >
                                <defs>
                                  <style
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        "\n                                                            .cls-1 {\n                                                                fill: #fff;\n                                                            }\n                                                            "
                                    }}
                                  />
                                </defs>
                                <title>tennis</title>
                                <path
                                  className="cls-1"
                                  d="M56.7,49.7,44.2,37.2h0l-4.1-4.1a4.76,4.76,0,0,1-1.2-4.7h0a18.66,18.66,0,0,0,.4-2.5,9.28,9.28,0,0,1-2.4.3,4.87,4.87,0,0,1-1.2-.1h0L20.4,10.8l4.4-4.4a20,20,0,0,1,3.7,2.8,9.92,9.92,0,0,1,2.6-2.4A24,24,0,0,0,15.1,0,15.1,15.1,0,0,0,4.3,4.2C-2.5,10.9-1,23.3,7.5,31.8c4.9,4.9,11.1,7.5,16.8,7.5a16.11,16.11,0,0,0,4.4-.6A4.76,4.76,0,0,1,33,39.9L49.4,56.3h0l.2.2,5.6-5.6,1.5-1.2ZM26.2,20.5l-5.4,5.4L13,18.2l5.4-5.4ZM15.1,3.5a16.33,16.33,0,0,1,7.1,1.6L18.5,8.8,13.4,3.7A7.93,7.93,0,0,1,15.1,3.5Zm-5,.9,6.3,6.3L11,16.2,4.7,9.8a11,11,0,0,1,2-3.1A11.34,11.34,0,0,1,10.1,4.4ZM3.6,16.9a14,14,0,0,1,.1-4.1L9,18.2l-4,4A19.78,19.78,0,0,1,3.6,16.9Zm2.8,7.9L11,20.2,18.8,28l-4.7,4.7A24.72,24.72,0,0,1,10,29.4,26,26,0,0,1,6.4,24.8Zm10.3,9.3L20.8,30l5.7,5.7a15,15,0,0,1-2.2.2A19.19,19.19,0,0,1,16.7,34.1Zm16-1.4a10.29,10.29,0,0,1-3.1,2l-6.8-6.8,5.4-5.4,6.7,6.7A9.88,9.88,0,0,1,32.7,32.7Z"
                                ></path>
                                <circle
                                  className="cls-1"
                                  cx="36.9"
                                  cy="15.6"
                                  r="7.1"
                                />
                              </svg>{" "}
                              Tennis{" "}
                            </div>
                          </th>
                          <th>Matched</th>
                          <th colSpan={2}>1</th>
                          <th colSpan={2}>X</th>
                          <th colSpan={2}>2</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        <EventRow
                          eventList={activeEventList}
                          tabName="tennis"
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={activeIndex === 2 ? "tab-pane active" : "tab-pane"}
              id="tabs-4"
              role="tabpanel"
            >
              <div className="wrapper-table-home football-tabpanel">
                <div className="tabcontent">
                  <div className="high_lights">
                    <table className="table">
                      <thead>
                        <tr>
                          <th colSpan={2} className="sport">
                            <div className="sport">
                              {" "}
                              <svg
                                id="soccer"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                              >
                                <defs>
                                  <style
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        "\n                                                            .cls-1 {\n                                                                fill: #fff;\n                                                            }\n                                                            "
                                    }}
                                  />
                                </defs>
                                <title>soccer</title>
                                <path
                                  className="cls-1"
                                  d="M12.5.3A11.34,11.34,0,0,0,10,0,11.34,11.34,0,0,0,7.5.3l2.5.9Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M14.3,19.1a9.83,9.83,0,0,0,3.7-3l-2.4.9Z"
                                />
                                <path
                                  className="cls-1"
                                  d="M19.3,6.3a7.19,7.19,0,0,0-1.2-2.1V6.8L20,8.9A7.71,7.71,0,0,0,19.3,6.3Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M2,16.1a9.83,9.83,0,0,0,3.7,3l-1.3-2Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M1.8,4.2A11.78,11.78,0,0,0,.7,6.1,12.76,12.76,0,0,0,0,8.9L1.8,6.7Z"
                                ></path>
                                <polygon
                                  className="cls-1"
                                  points="7 9.4 8.2 12.9 11.8 12.9 13 9.4 10 7.3 7 9.4"
                                ></polygon>
                                <path
                                  className="cls-1"
                                  d="M14.1,16.6l-2-2.1H7.9l-2,2.1,2,3.2A14.92,14.92,0,0,0,10,20a14.92,14.92,0,0,0,2.1-.2Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M19.2,14a.1.1,0,0,1,.1-.1,9,9,0,0,0,.7-2.7L17.3,8,14.5,9.6l-1.3,3.8,2,2.1Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M.8,14a.1.1,0,0,0-.1-.1A13.43,13.43,0,0,1,0,11.2L2.7,8,5.5,9.6l1.3,3.8-2,2.1Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M5.5,1.1A16.44,16.44,0,0,0,3.3,2.5V6.6L6,8.2,9.2,5.9V2.5Z"
                                ></path>
                                <path
                                  className="cls-1"
                                  d="M14.5,1.1,10.7,2.5V5.9l3.2,2.3,2.7-1.6V2.5A11,11,0,0,0,14.5,1.1Z"
                                ></path>
                              </svg>{" "}
                              Football{" "}
                            </div>
                          </th>
                          <th>Matched</th>
                          <th colSpan={2}>1</th>
                          <th colSpan={2}>X</th>
                          <th colSpan={2}>2</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        <EventRow
                          eventList={activeEventList}
                          tabName="football"
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </ClientLayout>
  );
}
